import { library, dom } from '@fortawesome/fontawesome-svg-core';

import * as icons from './icons';

library.add(...Object.values(icons));

dom.watch();